<template>
  <div id='header-content'>
    <div class='header'>
      <div class=header-flex>
        <svg-icon class='header-icon' iconName='logo'></svg-icon> 
        <span class='logo'>小桔IoT</span>
        <div class='navigation-box'>
          <span class='navigation' v-for='(item, index) in navigationList' :key='index' @click='jumpToEleId(item.id)'>{{item.name}}</span>
        </div>
      </div>
    </div>
    <div class='name'>滴滴出行物联网平台</div>
    <div class='desc'>提供专业完备的IoT一站式解决方案</div>
  </div>
</template>

<script>
import SvgIcon from './SvgIcon.vue';
export default {
  components: { SvgIcon },
  data() {
    return {
      navigationList: [
        {
          name: '产品概述',
          id: 'header-content'
        },
        {
          name: '产品优势',
          id: 'product-advantages'
        },
        {
          name: '产品功能',
          id: 'product-features'
        },
        {
          name: '接入方案',
          id: 'access-scheme'
        },
        {
          name: '应用场景',
          id: 'app-scenario'
        },
        {
          name: '平台架构',
          id: 'platform-structure'
        }
      ]
    }
  },
  methods: {
    jumpToEleId(id) {
      document.getElementById(id).scrollIntoView();
    }
  }
}
</script>

<style scoped>
#header-content {
  width: 100%;
  height: 469px;
  background-image: url('../assets/bg1.png');
  background-repeat: no-repeat;
  background-size: contain;
}
.header {
  width: 100%;
  height: 70px;
  background-color:rgba(6, 29, 54, 0.6);
  color: #fff;
  line-height:70px;
  text-align: left;
  position: fixed;
  top: 0;
}
.header-flex {
  display: flex;
}
.header-icon {
  width: 28px;
  height: 28px;
  padding-left: 120px;
  margin: 21px 10px 0 0;
}
.logo {
  /* padding-left: 121px; */
  font-size: 26px;
  display: inline;
  width: 142px;
  height: 45px;
  margin-right: 12px;
  letter-spacing: 2px;
}
.navigation-box {
  width: 612px;
  display: flex;
  justify-content: space-between;
  color: rgb(241, 243, 242);
  font-weight: 400;
}
.navigation {
  font-size: 17px;
  cursor: pointer;
}
.name {
  width:664px;
  height:96px;
  font-family:Montserrat;
  font-weight:700;
  color:#ffffff;
  font-size:72px;
  line-height:96px;
  margin: 0 0px 35px 121px;
  padding-top: 159px;
}
.desc {
  width:546px;
  height:48px;
  font-family:Montserrat;
  font-weight:500;
  color:#ffffff;
  font-size:34px;
  line-height:48px;
  margin-left: 121px;
}
@media (min-width:1441px) {
  #header-content{
    width: 100%;
    height: 100%vh;
    background-size: 100% 100%;
  }
}

</style>